import React from 'react'
import { useAuth } from '../../Auth/AuthProvider'
import { gravatarUrl } from '../../utils/gravatarUrl'

export default function ProfilePic(props) {
  const { email, photoURL } = useAuth()
  const size = props.size || 32
  const src = photoURL || (email ? gravatarUrl(email, size) : gravatarUrl('', size))

  return (
    <img
      src={src}
      alt=""
      width={size}
      height={size}
      style={props.style}
      className="rounded-full object-cover"
      referrerPolicy="no-referrer"
    />
  )
}
